// import '@/assets/css/normalize.scss'
import '@/assets/css/main.scss'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { store, key } from './store'
import { createPinia } from 'pinia'
import { http } from './utils/http'
import { sentry } from './plugins/sentry'
import { setupComponents } from './plugins/components'
import { setupDirectives } from './plugins/directives'
import { setupMethods } from './plugins/middlewares'
import { setupMixins } from './plugins/mixins'
import 'vant/lib/index.css'
import {
  Swipe,
  SwipeItem,
  Popup,
  Cell,
  CellGroup,
  Tabs,
  Tab,
  List,
  DropdownMenu,
  DropdownItem,
  Calendar,
  ActionSheet,
  RadioGroup,
  Radio,
  Grid,
  GridItem,
  Button,
  Checkbox,
  CheckboxGroup,
  Search,
  Empty,
  Loading,
  Sticky,
  Switch,
  Tag,
  Form,
  Field,
  DatetimePicker,
  Picker,
  Rate,
  Collapse,
  CollapseItem,
  Divider
} from 'vant'

const app = createApp(App)
app.use(Swipe)
app.use(SwipeItem)
app.use(Popup)
app.use(Cell)
app.use(CellGroup)
app.use(Tabs)
app.use(Tab)
app.use(List)
app.use(Calendar)
app.use(RadioGroup)
app.use(Radio)
app.use(ActionSheet)
app.use(Grid)
app.use(GridItem)
app.use(DropdownMenu)
app.use(DropdownItem)
app.use(Button)
app.use(Checkbox)
app.use(CheckboxGroup)
app.use(Search)
app.use(Empty)
app.use(Loading)
app.use(Sticky)
app.use(Tag)
app.use(Form)
app.use(Field)
app.use(DatetimePicker)
app.use(Picker)
app.use(Rate)
app.use(Collapse)
app.use(CollapseItem)
app.use(Divider)
// app.config.globalProperties.$router = router
// app.config.globalProperties.$store = store
app.config.globalProperties.$http = http

setupComponents(app)
setupDirectives()
setupMethods(app)
setupMixins(app)
app.use(sentry)

// 传入 injection key
app.use(store, key)
const pinia = createPinia()
app.use(pinia)

app.use(router)
app.mount('#app')
